import { RemainingCouponUsages } from 'types/models/coupons';

export enum COUPON_VALIDATION_ERRORS {
  INVALID_CODE,
  EXPIRY,
  CAMP_NOT_ALLOWED,
  COUPON_USAGE_TIMES,
  CUSTOMER_MAX_NIGHTS,
  CUSTOMER_USAGE_TIMES,
  CAMP_USAGE_TIMES,
  COUPON_MAX_NIGHTS,
  CAMP_MAX_NIGHTS,
  PURCHASE_MAX_NIGHTS,
  PURCHASE_MIN_NIGHTS,
  PURCHASE_MAX_SPENT_AMOUNT,
  COUPON_MAX_SPENT_AMOUNT,
  CUSTOMER_MAX_SPENT_AMOUNT,
  CAMP_MAX_SPENT_AMOUNT,
}

export interface CouponValidationResult {
  success: boolean;
  remainingUsages?: RemainingCouponUsages;
  errorCode?: COUPON_VALIDATION_ERRORS;
}

const localizationPath = 'reservation.coupon.validation';
export const DEFAULT_VALIDATION_ERROR = `${localizationPath}.couponCodeInvalid`;
export const VALIDATION_ERROR_MAP: Record<number, string> = {
  [COUPON_VALIDATION_ERRORS.INVALID_CODE]: `${localizationPath}.couponCodeInvalid`,
  [COUPON_VALIDATION_ERRORS.EXPIRY]: `${localizationPath}.couponExpired`,
  [COUPON_VALIDATION_ERRORS.CAMP_NOT_ALLOWED]: `${localizationPath}.invalidCamp`,
  [COUPON_VALIDATION_ERRORS.COUPON_USAGE_TIMES]: `${localizationPath}.usageLimitExceeded`,
  [COUPON_VALIDATION_ERRORS.CUSTOMER_MAX_NIGHTS]: `${localizationPath}.customerNightsLimitExceeded`,
};
